"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _styles = require("@material-ui/core/styles");
var _withWidth = _interopRequireDefault(require("@material-ui/core/withWidth"));
var _Card = _interopRequireDefault(require("@material-ui/core/Card"));
var _CardContent = _interopRequireDefault(require("@material-ui/core/CardContent"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _CheckCircle = _interopRequireDefault(require("@material-ui/icons/CheckCircle"));
var _Info = _interopRequireDefault(require("@material-ui/icons/Info"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));
var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));
var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));
var _DialogContentText = _interopRequireDefault(require("@material-ui/core/DialogContentText"));
var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));
var _upperFirst = _interopRequireDefault(require("lodash/upperFirst"));
var _i18n = require("../../../../../Framework/i18n");
var _ObjectTools = _interopRequireDefault(require("../ObjectTools"));
var _AnalyticsWrapper = _interopRequireDefault(require("../../../../Shared/Components/Analytics/AnalyticsWrapper"));
var _CustomDialog = _interopRequireDefault(require("../../../../../Shared/Components/CustomDialog"));
var _customClassName = _interopRequireDefault(require("../../../../Utils/customClassName"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var styles = function styles(theme) {
  var _CardContentWrapper;
  return {
    card: {
      borderTop: '7px solid ' + theme.palette.primary.main,
      position: 'relative',
      overflow: 'visible'
    },
    cardUnboxed: {
      borderTop: 'none',
      boxShadow: 'none',
      borderRadius: 0
    },
    CardContentWrapper: (_CardContentWrapper = {
      padding: 8
    }, _defineProperty(_CardContentWrapper, theme.breakpoints.down('xs'), {
      padding: '8px 0',
      '&:last-child': {
        paddingBottom: 12
      }
    }), _defineProperty(_CardContentWrapper, '& .object-btn', _defineProperty({}, theme.breakpoints.down('xs'), {
      height: 50,
      width: 50,
      margin: '15px 5px 0 0'
    })), _CardContentWrapper),
    printQuality: _defineProperty({
      display: 'inline-flex',
      alignItems: 'center',
      backgroundColor: '#000000',
      marginBottom: 15,
      borderRadius: '4px',
      color: '#fff',
      padding: '10px',
      width: '100%',
      minHeight: 40
    }, theme.breakpoints.down('xs'), {
      margin: 0,
      minHeight: 56
    }),
    printQualityText: {
      color: '#fff',
      padding: '0 10px',
      fontSize: 15,
      lineHeight: '18px'
    },
    printQualityGreat: {
      backgroundColor: '#4FC36D'
    },
    printQualityOk: {
      backgroundColor: '#FF9800'
    },
    printQualityPoor: {
      backgroundColor: '#ED1C29'
    },
    printQualityIcon: {
      verticalAlign: 'middle'
    },
    printQualityInfoIcon: {
      verticalAlign: 'middle',
      cursor: 'pointer'
    },
    editButtonLine: {
      margin: '15px 0'
    },
    editButton: _defineProperty({
      minWidth: 30,
      width: 35,
      margin: '0px 8px 0 0'
    }, theme.breakpoints.down('xs'), {
      margin: '15px 5px 0 0',
      height: 50,
      width: 50
    })
  };
};
var ImageControlbox = /*#__PURE__*/function (_React$Component) {
  _inherits(ImageControlbox, _React$Component);
  var _super = _createSuper(ImageControlbox);
  function ImageControlbox(props) {
    var _this;
    _classCallCheck(this, ImageControlbox);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "onEditClick", function () {
      var _this$props = _this.props,
        imageData = _this$props.imageData,
        openImageEditDialog = _this$props.openImageEditDialog,
        canvas = _this$props.canvas;
      if (imageData.isPlaceHolderImage) {
        openImageEditDialog(null, canvas, true);
      } else {
        openImageEditDialog(imageData.identifier, canvas);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onPrintQualityInfoClick", function () {
      _this.setState({
        printQualityInfoDialogOpen: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handlePrintQualityInfoDialogClose", function () {
      _this.setState({
        printQualityInfoDialogOpen: false
      });
    });
    _this.state = {
      printQualityInfoDialogOpen: false
    };
    return _this;
  }
  _createClass(ImageControlbox, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        classes = _this$props2.classes,
        boxed = _this$props2.boxed,
        printQuality = _this$props2.printQuality,
        handleObjectButtonClick = _this$props2.handleObjectButtonClick,
        flipToFrontDisabled = _this$props2.flipToFrontDisabled,
        flipToBackDisabled = _this$props2.flipToBackDisabled;
      var printQualityInfoDialogOpen = this.state.printQualityInfoDialogOpen;
      var printQualityInfoExists = (0, _i18n.translationExists)('imageControlbox.printQualityInfo.' + this.props.printQuality);
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Card["default"], {
        className: (0, _clsx["default"])(boxed ? classes.card : classes.cardUnboxed, (0, _customClassName["default"])('image-tools-box'))
      }, /*#__PURE__*/_react["default"].createElement(_CardContent["default"], {
        className: boxed ? '' : classes.CardContentWrapper
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        lg: 12
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        alignItems: "center"
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        lg: printQualityInfoExists ? 10 : 12,
        className: classes.printQuality + ' ' + classes['printQuality' + (0, _upperFirst["default"])(printQuality)]
      }, /*#__PURE__*/_react["default"].createElement(_CheckCircle["default"], {
        className: classes.printQualityIcon
      }), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        variant: "body1",
        component: "span",
        className: classes.printQualityText
      }, (0, _i18n.t)('imageControlbox.printQualityLabel'), ":", ' ', (0, _i18n.t)('imageControlbox.printQuality.' + printQuality))), printQualityInfoExists && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        lg: 2,
        align: "center"
      }, /*#__PURE__*/_react["default"].createElement(_Info["default"], {
        className: classes.printQualityInfoIcon,
        onClick: this.onPrintQualityInfoClick
      })))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 10,
        md: 8,
        lg: 8
      }, /*#__PURE__*/_react["default"].createElement(_ObjectTools["default"], {
        handleObjectButtonClick: handleObjectButtonClick,
        flipToFrontDisabled: flipToFrontDisabled,
        flipToBackDisabled: flipToBackDisabled
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 2,
        md: 4,
        lg: 4
      }, /*#__PURE__*/_react["default"].createElement(_AnalyticsWrapper["default"], {
        targetId: "edit_image"
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        style: {
          "float": 'right'
        },
        className: classes.editButton,
        variant: "outlined",
        onClick: this.onEditClick
      }, /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
        title: (0, _i18n.t)('imageControlbox.editButtonTooltip')
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], null, "edit")))))))), /*#__PURE__*/_react["default"].createElement(_CustomDialog["default"], {
        open: printQualityInfoDialogOpen,
        onClose: this.handlePrintQualityInfoDialogClose,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description"
      }, /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], null, /*#__PURE__*/_react["default"].createElement(_DialogContentText["default"], {
        id: "alert-dialog-description"
      }, (0, _i18n.t)('imageControlbox.printQualityInfo.' + printQuality))), /*#__PURE__*/_react["default"].createElement(_DialogActions["default"], null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: this.handlePrintQualityInfoDialogClose,
        color: "primary"
      }, "OK"))));
    }
  }]);
  return ImageControlbox;
}(_react["default"].Component);
var _default = exports["default"] = (0, _withWidth["default"])({
  initialWidth: 'lg'
})((0, _styles.withStyles)(styles, {
  name: 'ImageControlbox'
})(ImageControlbox));